<div class="card full-card shadow-sm m-4 card-v-center mt-4">
  <div class="card-body">
    <div style="text-align: center">
      @if (errors.length == 0) {
        <h1 translate>delegation-confirmed.title-success</h1>
      }
      @if (errors.length > 0) {
        <h1 class="mt-4 errors">
          @if (errors.length == 1) {
            <span translate
              >delegation-confirmed.error-list.title-singular</span
              >
            }
            @if (errors.length > 1) {
              <span translate
                >delegation-confirmed.error-list.title-plural</span
                >
              }
            </h1>
            <ul class="mt-2 list-group">
              @for (error of errors; track error) {
                <li class="list-group-item">
                  {{ error }}
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
